module.exports = __webpack_public_path__ + "static/media/banner-not-found.d7beb366.jpg";